import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSizeEnum } from '../../enum/modal-size.enum';
import { RoleCodeEnum } from '../../enum/role-code.enum';
import { GeneralUtils } from '../../utils/general.utils';
import { HelpVideoUrlModel } from '../../models/entity/help-video-url.model';
import { AlertifyService } from '../../services/core/alertify.service';
import { HelpVideoUrlService } from '../../services/core/help-video-url.service';
import { HelpVideoAddUpdateComponent } from '../help-video-add-update/help-video-add-update.component';
import { ArrayUtils } from '../../utils/array.utils';

@Component({
  selector: 'app-help-video-modal',
  templateUrl: './help-video-modal.component.html',
  styleUrls: ['./help-video-modal.component.css']
})
export class HelpVideoModalComponent implements OnInit {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  dataList: HelpVideoUrlModel[] = [];
  loading = false;

  data: HelpVideoUrlModel = new HelpVideoUrlModel();

  isNewData: boolean;

  searchText: string;
  page = 1;
  pageSize = 12;
  roleCodeEnum = RoleCodeEnum;

  constructor(

    private modalService: NgbModal,
    private alertifyService: AlertifyService,
    private helpVideoUrlService: HelpVideoUrlService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.helpVideoUrlService.getVideoUrls().subscribe(
      data => {
        this.dataList = data;
        this.dataList = ArrayUtils.sortBy(this.dataList, "screenOrderNo");
        this.loading = false;
      },

      err => {
        this.alertifyService.error(err);
        this.loading = false;
      }
    );
  }

  // Modal ekleme güncelleme
  openAddUpdateModal(rowData) {

    const modalRef = this.modalService.open(HelpVideoAddUpdateComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM
    });

    // eğer güncelleme ise bu değer dolu geliyor
    if (rowData) {
      this.isNewData = false;
      this.data = rowData;
    }
    else {
      this.isNewData = true;
      this.data = new HelpVideoUrlModel();
    }

    //modal  veri geçişi
    modalRef.componentInstance.data = GeneralUtils.clone(this.data);

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      // Cevap boş değilse
      if (receivedEntry) {

        if (this.isNewData)
          this.dataList = this.dataList.concat(receivedEntry);
        else {
          ArrayUtils.replace(this.dataList, this.data, receivedEntry);
          this.dataList = this.dataList.slice();
        }
        this.data = receivedEntry;
      }

      // modal kapat
      modalRef.close();
    });

  }



  close() {
    this.passEntry.emit();
  }

  openInYouTube(video: HelpVideoUrlModel) {
    if (!video || !video.url) {
      return;
    }

    let youtubeUrl = video.url.trim();
    let videoId = '';

    if (youtubeUrl.includes('youtu.be/')) {
      videoId = youtubeUrl.split('youtu.be/')[1].split('?')[0].split('&')[0];
    } else if (youtubeUrl.includes('youtube.com/watch?v=')) {
      videoId = youtubeUrl.split('watch?v=')[1].split('&')[0];
    } else if (youtubeUrl.includes('youtube.com/embed/')) {
      videoId = youtubeUrl.split('embed/')[1].split('?')[0].split('&')[0];
    } else if (youtubeUrl.includes('youtube.com/v/')) {
      videoId = youtubeUrl.split('v/')[1].split('?')[0].split('&')[0];
    }

    if (videoId) {
      window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
    } else {
      window.open(youtubeUrl, '_blank');
    }
  }
}
